<template>
  <div class="landing-page">
    <div class="collapse-wrap">
      <b-collapse class="card" animation="slide" :open="false">
        <template #trigger="props">
          <div class="card-header" role="button" :aria-expanded="props.open">
            <div class="card-header-left-panel">
              <p class="card-header-title">Top slide</p>
            </div>

            <div class="card-header-right-panel">
              <b-button type="is-primary" outlined @click="activateModal('slide', null)">ADD SLIDE</b-button>
              <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon></a>
            </div>
          </div>
        </template>
        <div class="card-content">
          <div class="content topslide" v-if="slides.length > 0">
            <div class="card" v-for="slide in slides" :key="slide.id">
              <div class="slide-cover-image-panel">
                <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + slide.image" class="field" />
              </div>
              <div class="details">
                <div class="flex">
                  <div class="slide-session-item-title">
                    <span>{{ slide.title }}</span>
                  </div>
                  <div class="slide-session-item-option">
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item @click="activateModal('slide', slide)"
                        aria-role="listitem">Update</b-dropdown-item>
                      <b-dropdown-item @click="deleteItem(slide, 'slide')" aria-role="listitem">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="slide-session-item-body-panel">
                  {{ slide.description }}
                </div>
                <b-field label="">
                  <span class="link"><a :href="slide.link">{{ slide.link }}</a></span>
                </b-field>
              </div>
            </div>
          </div>
          <label class="nodata" v-else>No slides available</label>
        </div>
      </b-collapse>
    </div>
    <div class="collapse-wrap">
      <b-collapse class="card" animation="slide">
        <template #trigger="props">
          <div class="card-header" role="button" :aria-expanded="props.open">
            <div class="card-header-left-panel">
              <p class="card-header-title">About us</p>
            </div>
            <div class="card-header-right-panel">
              <b-button type="is-primary" outlined @click="activateModal('about', about)">EDIT ABOUT</b-button>
              <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon></a>
            </div>
          </div>
        </template>
        <div class="about-content">
          <div class="body" v-if="about">
            <div class="about-cover-image-panel">
              <b-field label="Cover">
                <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + about.image" class="field" />
              </b-field>
            </div>
            <div class="details">
              <div class="flex">
                <b-field label="Title">
                  <div class="about-title">
                    <span>{{ about.title }}</span>
                  </div>
                </b-field>
              </div>

              <b-field label="Vision">
                <div class="about-body-panel">
                  {{ about.vision }}
                </div>
              </b-field>
              <b-field label="Mission">
                <div class="about-body-panel">
                  {{ about.mission }}
                </div>
              </b-field>
              <b-field label="Values">
                <div class="about-body-panel">
                  {{ about.values }}
                </div>
              </b-field>

              <b-field label="Description">
                <div class="about-body-panel">
                  {{ about.description }}
                </div>
              </b-field>

              <b-field label="Links">
                <a v-if="about.facebookLink" :href="about.facebookLink" target="_blank"><img width="20"
                    src="@/assets/images/social-media/facebook.svg" class="about-icon"></a>
                <a v-if="about.instagramLink" :href="about.instagramLink" target="_blank"><img width="20"
                    src="@/assets/images/social-media/instagram.svg" class="about-icon"></a>
                <a v-if="about.linkedInLink" :href="about.linkedInLink" target="_blank"><img width="20"
                    src="@/assets/images/social-media/linkedin.svg" class="about-icon"></a>
                <a v-if="about.xLink" :href="about.xLink" target="_blank"><img width="20"
                    src="@/assets/images/social-media/x-logo.png" class="about-icon"></a>
                <a v-if="about.tiktokLink" :href="about.tiktokLink" target="_blank"><img width="24"
                    src="@/assets/images/social-media/tikok.png" class="about-icon"></a>
                <a v-if="about.youtubeLink" :href="about.youtubeLink" target="_blank"><img width="35"
                    src="@/assets/images/social-media/youtube.png" class="about-icon"></a>
                <a v-if="about.spotifyLink" :href="about.spotifyLink" target="_blank"><img width="25"
                    src="@/assets/images/social-media/spotify.png" class="about-icon"></a>
                <a v-if="about.soundcloudLink" :href="about.soundcloudLink" target="_blank"><img width="26"
                    src="@/assets/images/social-media/soundcloud.png" class="about-icon"></a>
                <a v-if="about.vimeoLink" :href="about.vimeoLink" target="_blank"><img width="28"
                    src="@/assets/images/social-media/vimeo.png" class="about-icon"></a>
                <a v-if="about.twitchLink" :href="about.twitchLink" target="_blank"><img width="28"
                    src="@/assets/images/social-media/twitch.png" class="about-icon"></a>
                <a v-if="about.applemusicLink" :href="about.applemusicLink" target="_blank"><img width="23"
                    src="@/assets/images/social-media/applemusic.png" class="about-icon"></a>
                <a v-if="about.bandcampLink" :href="about.bandcampLink" target="_blank"><img width="25"
                    src="@/assets/images/social-media/bandcamp.png" class="about-icon"></a>
                <a v-if="about.trillerLink" :href="about.trillerLink" target="_blank"><img width="29"
                    src="@/assets/images/social-media/triller.png" class="about-icon"></a>
                <a v-if="about.vevoLink" :href="about.vevoLink" target="_blank"><img width="35"
                    src="@/assets/images/social-media/vevo.png" class="about-icon"></a>
                <a v-if="about.deezerLink" :href="about.deezerLink" target="_blank"><img width="25"
                    src="@/assets/images/social-media/deezer.png" class="about-icon"></a>
                <a v-if="about.smuleLink" :href="about.smuleLink" target="_blank"><img width="24"
                    src="@/assets/images/social-media/smule.png" class="about-icon"></a>
                <a v-if="about.pinterestLink" :href="about.pinterestLink" target="_blank"><img width="24"
                    src="@/assets/images/social-media/pinterest.png" class="about-icon"></a>
                <a v-if="about.whatsappLink" :href="about.whatsappLink" target="_blank"><img width="24"
                    src="@/assets/images/social-media/whatsapp.png" class="about-icon"></a>
                <a v-if="about.redditLink" :href="about.redditLink" target="_blank"><img width="24"
                    src="@/assets/images/social-media/reddit.png" class="about-icon"></a>
                <a v-if="about.audiomackLink" :href="about.audiomackLink" target="_blank"><img width="24"
                    src="@/assets/images/social-media/audiomack.png" class="about-icon"></a>
                <a v-if="about.boomplayLink" :href="about.boomplayLink" target="_blank"><img width="24"
                    src="@/assets/images/social-media/boomplay.png" class="about-icon"></a>
              </b-field>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
    <div class="collapse-wrap">
      <b-collapse class="card" animation="slide">
        <template #trigger="props">
          <div class="card-header" role="button" :aria-expanded="props.open">
            <div class="card-header-left-panel">
              <p class="card-header-title">Gallery</p>
            </div>
            <div class="card-header-right-panel">
              <b-button type="is-primary" outlined @click="activateModal('gallery', about)">EDIT GALLERY</b-button>
              <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon></a>
            </div>
          </div>
        </template>
        <div class="gallery-images-content">
          <div class="gallery-image-item" v-for="(image, index) in gallery" :key="index">
            <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + image" class="image-item">
          </div>
        </div>
      </b-collapse>
    </div>
    <div class="collapse-wrap">
      <b-collapse class="card" animation="slide" :open="true">
        <template #trigger="props">
          <div class="card-header" role="button" :aria-expanded="props.open">
            <div class="card-header-left-panel">
              <p class="card-header-title">Our services</p>
            </div>

            <div class="card-header-right-panel">
              <b-button type="is-primary" outlined @click="activateModal('service', null)">ADD
                SERVICE</b-button>
              <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon></a>
            </div>
          </div>
        </template>
        <div class="card-content">
          <div class="content topslide" v-if="services.length > 0">
            <div class="card" v-for="service in services" :key="service.id">
              <div class="slide-cover-image-panel">
                <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + service.image" class="field" />
              </div>
              <div class="details">
                <div class="flex">
                  <div class="slide-session-item-title">
                    <span>{{ service.title }}</span>
                  </div>
                  <div class="slide-session-item-option">
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item @click="activateModal('service', service)"
                        aria-role="listitem">Update</b-dropdown-item>
                      <b-dropdown-item @click="deleteItem(service, 'service')"
                        aria-role="listitem">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="slide-session-item-body-panel">
                  {{ service.description }}
                </div>
              </div>
            </div>
          </div>
          <label class="nodata" v-else>No services listing</label>
        </div>
      </b-collapse>
    </div>
    <div class="collapse-wrap">
      <b-collapse class="card" animation="slide" :open="false">
        <template #trigger="props">
          <div class="card-header" role="button" :aria-expanded="props.open">
            <div class="card-header-left-panel">
              <p class="card-header-title">Our projects</p>
            </div>

            <div class="card-header-right-panel">
              <b-button type="is-primary" outlined @click="activateModal('project', null)">ADD
                PROJECT</b-button>
              <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon></a>
            </div>
          </div>
        </template>
        <div class="card-content">
          <div class="content topslide" v-if="projects.length > 0">
            <div class="card" v-for="project in projects" :key="project.id">
              <div class="slide-cover-image-panel">
                <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + project.image" class="field" />
              </div>
              <div class="details">
                <div class="flex">
                  <div class="slide-session-item-title">
                    <span>{{ project.title }}</span>
                  </div>
                  <div class="slide-session-item-option">
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item @click="activateModal('project', project)"
                        aria-role="listitem">Update</b-dropdown-item>
                      <b-dropdown-item @click="deleteItem(project, 'project')"
                        aria-role="listitem">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="slide-session-item-body-panel">
                  {{ project.description }}
                </div>
                <b-field label="">
                  <span class="link"><a href="https:///www.google.com">Link</a></span>
                </b-field>
              </div>
            </div>
          </div>
          <label class="nodata" v-else>No projects listing</label>
        </div>
      </b-collapse>
    </div>
    <div class="collapse-wrap">
      <b-collapse class="card" animation="slide" :open="true">
        <template #trigger="props">
          <div class="card-header" role="button" :aria-expanded="props.open">
            <div class="card-header-left-panel">
              <p class="card-header-title">Our Teams</p>
            </div>
            <div class="card-header-right-panel">
              <b-button type="is-primary" outlined @click="activateModal('member', null)">ADD
                MEMBER</b-button>
              <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon></a>
            </div>

          </div>
        </template>
        <div class="card-content">
          <div class="content topslide" v-if="members.length > 0">
            <div class="card" v-for="member in members" :key="member.id">
              <div class="slide-cover-image-panel">
                <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + member.image" class="field" />
              </div>
              <div class="details">
                <div class="flex">
                  <b-field label="Name">
                    <span>{{ member.name }}</span>
                  </b-field>
                  <div class="slide-session-item-option">
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item @click="activateModal('member', member)"
                        aria-role="listitem">Update</b-dropdown-item>
                      <b-dropdown-item @click="deleteItem(member, 'member')" aria-role="listitem">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <b-field label="Title">
                  {{ member.title }}
                </b-field>
                <b-field label="Description">
                  {{ member.description }}
                </b-field>
                <b-field label="Summary">
                  {{ member.description }}
                </b-field>
                <b-field label="Full information" v-if="member.fullInformation">
                  {{ member.fullInformation }}
                </b-field>
                <b-field label="Links">
                  <a :href="member.facebookLink" target="_blank"><img src="@/assets/images/social-media/facebook.svg"
                      alt="" class="icon"></a>
                  <a :href="member.instagramLink" target="_blank"><img src="@/assets/images/social-media/instagram.svg"
                      alt="" class="icon"></a>
                  <a :href="member.linkedinLink" target="_blank"><img src="@/assets/images/social-media/linkedin.svg"
                      alt="" class="icon"></a>
                </b-field>
              </div>
            </div>
          </div>
          <label class="nodata" v-else>No members listing</label>
        </div>
      </b-collapse>

    </div>
    <!-- Modal -->
    <AddUpdateLanding :type="type" v-if="show_modal" @close="show_modal = false" :current="currentData"
      @success="refreshUpdate"></AddUpdateLanding>
  </div>
</template>

<script>
import AddUpdateLanding from './add_update_landing.vue'
export default {
  components: { AddUpdateLanding },
  data() {
    return {
      show_modal: false,
      type: null,
      newData: {
        image: '',
        title: '',
        name: '',
        description: '',
        summary: '',
        fullInformation: '',
        link: '',
        tags: '',
        email: '',
        phone: '',
        instagramLink: '',
        facebookLink: '',
        linkedinLink: '',
        xLink: '',
        tiktokLink: '',
        youtubeLink: '',
        spotifyLink: '',
        soundcloudLink: '',
        vimeoLink: '',
        twitchLink: '',
        applemusicLink: '',
        bandcampLink: '',
        trillerLink: '',
        vevoLink: '',
        deezerLink: '',
        smuleLink: '',
        pinterestLink: '',
        whatsappLink: '',
        redditLink: '',
        audiomackLink: '',
        boomplayLink: '',
        gallery: null,
      },
      currentData: {
        image: '',
        title: '',
        name: '',
        description: '',
        summary: '',
        fullInformation: '',
        link: '',
        tags: '',
        email: '',
        phone: '',
        instagramLink: '',
        facebookLink: '',
        linkedinLink: '',
        xLink: '',
        tiktokLink: '',
        youtubeLink: '',
        spotifyLink: '',
        soundcloudLink: '',
        vimeoLink: '',
        twitchLink: '',
        applemusicLink: '',
        bandcampLink: '',
        trillerLink: '',
        vevoLink: '',
        deezerLink: '',
        smuleLink: '',
        pinterestLink: '',
        whatsappLink: '',
        redditLink: '',
        audiomackLink: '',
        boomplayLink: '',
        gallery: null,
      },
      slides: [],
      projects: [],
      services: [],
      about: null,
      members: []
    }
  },
  computed: {
    gallery() {
      let vm = this
      return vm.about && vm.about.gallery ? JSON.parse(vm.about.gallery) : [];
    }
  },
  methods: {
    activateModal(type, data) {
      let vm = this;
      vm.type = type
      data ? vm.currentData = data : vm.currentData = vm.newData
      vm.show_modal = true
    },
    deleteItem(item, name) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: `Deleting ${name}`,
        message: `Are you sure you want to <b>delete</b> this ${name}? This action cannot be undone.`,
        confirmText: `Delete ${name}`,
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          if (name === 'slide') {
            vm.$store
              .dispatch("SLIDES_DELETE_SLIDE", {
                id: item.id,
              })
              .then((response) => {
                vm.getAllSlides();
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: "Something went wrong, Contact your administrator",
                });
              });
          } else if (name === 'service') {
            vm.$store
              .dispatch("SERVICES_DELETE_SERVICE", {
                id: item.id,
              })
              .then((response) => {
                vm.getAllServices();
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: "Something went wrong, Contact your administrator",
                });
              });
          } else if (name === 'project') {
            vm.$store
              .dispatch("PROJECTS_DELETE_PROJECT", {
                id: item.id,
              })
              .then((response) => {
                vm.getAllProjects();
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: "Something went wrong, Contact your administrator",
                });
              });
          } else if (name === 'member') {
            vm.$store
              .dispatch("MEMBERS_DELETE_MEMBER", {
                id: item.id,
              })
              .then((response) => {
                vm.getAllMembers();
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: "Something went wrong, Contact your administrator",
                });
              });
          }
        }
      })
    },
    refreshUpdate(items) {
      let vm = this
      if (items == 'slides') { vm.getAllSlides() }
      else if (items == 'about') { vm.getAboutInfo() }
      else if (items == 'services') { vm.getAllServices() }
      else if (items == 'projects') { vm.getAllProjects() }
      else if (items == 'members') { vm.getAllMembers() }
    },
    close() {
      let vm = this;
      vm.show_modal = false
      vm.form = {
        id: null,
        image: '',
        title: '',
        name: '',
        description: '',
        summary: '',
        email: '',
        fullInformation: '',
        link: '',
        tags: '',
        phone: '',
        instagramLink: '',
        facebookLink: '',
        linkedinLink: ''
      };
    },
    getAllSlides() {
      let vm = this;
      vm.$store.dispatch('SLIDES_GET_ALL_SLIDES')
        .then(response => {
          vm.slides = response.data.return
        })
    },
    getAboutInfo() {
      let vm = this;
      vm.$store.dispatch('ABOUT_GET_INFO_ABOUT')
        .then(response => {
          vm.about = response.data.return
        })
    },
    getAllServices() {
      let vm = this;
      vm.$store.dispatch('SERVICES_GET_ALL_SERVICES')
        .then(response => {
          vm.services = response.data.return
        })
    },
    getAllProjects() {
      let vm = this;
      vm.$store.dispatch('PROJECTS_GET_ALL_PROJECTS')
        .then(response => {
          vm.projects = response.data.return
        })
    },
    getAllMembers() {
      let vm = this;
      vm.$store.dispatch('MEMBERS_GET_ALL_MEMBERS')
        .then(response => {
          vm.members = response.data.return
        })
    }
  },
  mounted() {
    let vm = this
    vm.getAllSlides()
    vm.getAboutInfo()
    vm.getAllServices()
    vm.getAllProjects()
    vm.getAllMembers()
  }
}
</script>

<style lang="scss" scoped>
.landing-page {
  position: relative;
  overflow-y: auto;
  width: 100%;


  .card-header {
    position: sticky;
    top: 0px;
    background-color: #fff;
    z-index: 99;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;

    .card-header-right-panel {
      display: flex;
      align-items: center;
    }
  }

  .card-content {
    .content {
      &.topslide {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 20px;

        @media (max-width: 1370px) {
          grid-template-columns: 1fr 1fr;
        }

        @media (max-width: 1050px) {
          grid-template-columns: 1fr;
        }

        @media (max-width: 965px) {
          grid-template-columns: 1fr 1fr;
        }

        @media (max-width: 860px) {
          grid-template-columns: 1fr;
        }

        @media (max-width: 800px) {
          grid-template-columns: 1fr 1fr;
        }

        @media (max-width: 635px) {
          grid-template-columns: 1fr;
        }

        .card {
          // background: #F3F3F3;
          border-radius: 7px;
          overflow: hidden;

          .slide-cover-image-panel {
            height: 200px;
            width: 100%;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .details {
            padding: 20px;

            .flex {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin: 0 0 10px;
            }

            .slide-session-item-title {
              font-size: 14px;
              font-weight: 600;
              color: #333;
              width: calc(100% - 60px);
              padding: 0px 10px;
            }

            .slide-session-item-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
            }

            .slide-session-item-body-panel {
              padding: 0px 10px;
              margin: 0 0 10px;
            }

            .link {
              margin: 30px 0 0 10px;
            }

            a {
              .icon {
                width: 20px;
                margin-left: 15px;
              }
            }
          }
        }
      }
    }
  }

  .about-content {
    padding: 20px;

    .body {
      .about-cover-image-panel {
        height: 300px;
        width: 700px;
        border-radius: 5px;
        overflow: hidden;

        @media (max-width: 1050px) {
          width: 100%;
        }

        @media (max-width: 480px) {
          height: 200px;
        }

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }

      .details {
        padding: 20px;

        .flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 0 10px;
        }

        .about-title {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          padding: 0px 10px;
        }

        .about-body-panel {
          padding: 0px 10px;
        }

        a {


          .about-icon {
            object-fit: contain;
            margin-left: 15px;
          }
        }
      }



    }
  }

  .gallery-images-content {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 20px;
    padding: 20px;

    .gallery-image-item {
      height: 130px;
      border-radius: 5px;
      overflow: hidden;
      border: 1px solid #ddd;
      padding: 10px;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>